var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalIconWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 80,
    viewBox: "0 0 67 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F96"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M0 3.333v73.334A3.333 3.333 0 0 0 3.333 80h60.334A3.333 3.333 0 0 0 67 76.667V21.58c0-.444-.177-.869-.491-1.182L46.496.485A1.666 1.666 0 0 0 45.321 0H3.333A3.333 3.333 0 0 0 0 3.333z",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M36.242 24.884a3 3 0 0 0-5.194 0L14.65 53.231a3 3 0 0 0 2.597 4.502h32.798a3 3 0 0 0 2.597-4.502l-16.4-28.347z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M33.5 33v14",
    opacity: 0.504
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 52,
    r: 1,
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.497
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F96",
    fillRule: "nonzero",
    d: "M46.063 0v17.227a3.333 3.333 0 0 0 3.333 3.333h17.337",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconWarning);
export default __webpack_public_path__ + "static/media/modal-icon-warning.794a6e56.svg";
export { ForwardRef as ReactComponent };